// i18n simple pour la landing Petwell
// Pour ajouter une langue :
// 1) Ajouter une entrée dans `translations` (ex. `en`).
// 2) Ajouter un bouton avec `data-lang="en"` dans le sélecteur de langue.
// 3) Reprendre les mêmes clés que pour `fr` / `it`.

const translations = {
  fr: {
    // Meta
    'meta.title': 'Petwell – La solution digitale des pros du bien‑être animal',
    'meta.description':
      "Petwell : agenda en ligne, réservations, rappels automatiques, statistiques, paiements sécurisés et vitrine digitale pour les pros du bien-être animal.",

    // Hero
    'hero.title': 'La solution digitale des pros du bien‑être animal',
    'hero.cta': 'Demandez une démo',

    // Intro
    'intro.title': 'Une plateforme simple et efficace pour tout centraliser',
    'intro.text':
      "Les professionnels du bien‑être animal manquent de visibilité, perdent du temps avec l'administratif et peinent à gérer les paiements. Petwell simplifie et centralise tout.",

    // Features
    'features.title': 'Fonctionnalités',
    'features.agenda': 'Agenda en ligne',
    'features.vitrine': 'Vitrine digitale',
    'features.secure_payment': 'Paiement sécurisé',
    'features.stats': 'Statistiques et rapports',
    'features.booking': 'Réservations en ligne',
    'features.reminders': 'Rappels automatiques',

    // Prepay
    'prepay.title': 'Prépaiement pour limiter les no-show',
    'prepay.text':
      "Petwell intègre un système de prépaiement et de paiement fractionné pour sécuriser les rendez-vous : moins d’annulations de dernière minute et plus de sérénité pour les professionnels.",

    // Mobile
    'mobile.title': 'Un outil mobile pour les pros en mouvement',
    'mobile.text':
      'Avec Petwell, les professionnels gèrent leur agenda, leurs réservations et leur vitrine digitale directement depuis leur smartphone. Une solution simple et flexible, idéale en déplacement.',

    // Reviews
    'reviews.title': "Ce qu'en pense nos clients",
    'reviews.card1.text': 'PetWell m’a permis de gagner 30% de temps sur ma gestion.',
    'reviews.card1.role': 'Éducatrice',
    'reviews.card2.text': 'Enfin une vitrine en ligne adaptée à mon métier.',
    'reviews.card2.role': 'Comportementaliste',
    'reviews.card3.text':
      'Grâce aux acomptes en ligne avec PetWell, j’ai réduit mes rendez-vous manqués de 50%.',
    'reviews.card3.role': 'Toiletteuse',

    // Contact
    'contact.title': 'Contactez-nous',
    'contact.phone_label': 'Téléphone',
    'contact.email_label': 'Email',

    // Footer
    'footer.copyright': '© 2025 Petwell. Tous droits réservés.',

    // Alts
    'alt.hero_image': 'Chat et chien',
    'alt.cat_on_sofa': "Chat sur un ordinateur portable",
    'alt.dog_head': 'Chiot couché',
    'alt.cat_and_mouse': "Chat derrière une souris d’ordinateur",
    'alt.cat_headphone': 'Chat avec mégaphone et lunettes',
  },

  it: {
    // Meta
    'meta.title': 'Petwell – La soluzione digitale per i professionisti del benessere animale',
    'meta.description':
      'Petwell: agenda online, prenotazioni, promemoria automatici, statistiche, pagamenti sicuri e vetrina digitale per i professionisti del benessere animale.',

    // Hero
    'hero.title': 'La soluzione digitale per i professionisti del benessere animale',
    'hero.cta': 'Richiedi una demo',

    // Intro
    'intro.title': 'Una piattaforma semplice ed efficace per centralizzare tutto',
    'intro.text':
      "I professionisti del benessere animale mancano di visibilità, perdono tempo con l’amministrativo e faticano a gestire i pagamenti. Petwell semplifica e centralizza tutto.",

    // Features
    'features.title': 'Funzionalità',
    'features.agenda': 'Agenda online',
    'features.vitrine': 'Vetrina digitale',
    'features.secure_payment': 'Pagamento sicuro',
    'features.stats': 'Statistiche e report',
    'features.booking': 'Prenotazioni online',
    'features.reminders': 'Promemoria automatici',

    // Prepay
    'prepay.title': 'Prepagamento per ridurre i no-show',
    'prepay.text':
      'Petwell integra un sistema di prepagamento e di pagamento a rate per rendere gli appuntamenti più sicuri: meno cancellazioni all’ultimo minuto e più serenità per i professionisti.',

    // Mobile
    'mobile.title': 'Uno strumento mobile per i professionisti in movimento',
    'mobile.text':
      'Con Petwell i professionisti gestiscono agenda, prenotazioni e vetrina digitale direttamente dallo smartphone. Una soluzione semplice e flessibile, ideale in spostamento.',

    // Reviews
    'reviews.title': 'Cosa pensano i nostri clienti',
    'reviews.card1.text': 'PetWell mi ha fatto risparmiare il 30% del tempo sulla gestione.',
    'reviews.card1.role': 'Educatrice',
    'reviews.card2.text': 'Finalmente una vetrina online adatta al mio mestiere.',
    'reviews.card2.role': 'Comportamentista',
    'reviews.card3.text':
      'Grazie agli acconti online con PetWell ho dimezzato gli appuntamenti mancati.',
    'reviews.card3.role': 'Toelettatrice',

    // Contact
    'contact.title': 'Contattaci',
    'contact.phone_label': 'Telefono',
    'contact.email_label': 'Email',

    // Footer
    'footer.copyright': '© 2025 Petwell. Tutti i diritti riservati.',

    // Alts
    'alt.hero_image': 'Gatto e cane',
    'alt.cat_on_sofa': 'Gatto al computer',
    'alt.dog_head': 'Cucciolo sdraiato',
    'alt.cat_and_mouse': 'Gatto dietro un mouse del computer',
    'alt.cat_headphone': 'Gatto con megafono e occhiali',
  },

  el: {
    // Meta
    'meta.title': 'Petwell – Η ψηφιακή λύση για τους επαγγελματίες ευζωίας ζώων',
    'meta.description':
      'Petwell: online ημερολόγιο, κρατήσεις, αυτόματες υπενθυμίσεις, στατιστικά, ασφαλείς πληρωμές και ψηφιακή βιτρίνα για τους επαγγελματίες ευζωίας ζώων.',

    // Hero
    'hero.title': 'Η ψηφιακή λύση για τους επαγγελματίες ευζωίας ζώων',
    'hero.cta': 'Ζητήστε μια επίδειξη',

    // Intro
    'intro.title': 'Μια απλή και αποτελεσματική πλατφόρμα για να τα κεντροποιήσετε όλα',
    'intro.text':
      'Οι επαγγελματίες ευζωίας ζώων έχουν μικρή ορατότητα, χάνουν χρόνο με τη διοικητική δουλειά και δυσκολεύονται να διαχειριστούν τις πληρωμές. Το Petwell απλοποιεί και κεντροποιεί τα πάντα.',

    // Features
    'features.title': 'Λειτουργίες',
    'features.agenda': 'Online ημερολόγιο',
    'features.vitrine': 'Ψηφιακή βιτρίνα',
    'features.secure_payment': 'Ασφαλής πληρωμή',
    'features.stats': 'Στατιστικά και αναφορές',
    'features.booking': 'Online κρατήσεις',
    'features.reminders': 'Αυτόματες υπενθυμίσεις',

    // Prepay
    'prepay.title': 'Προπληρωμή για να μειωθούν τα no‑show',
    'prepay.text':
      'Το Petwell ενσωματώνει σύστημα προπληρωμής και τμηματικών πληρωμών ώστε τα ραντεβού να είναι πιο ασφαλή: λιγότερες ακυρώσεις της τελευταίας στιγμής και περισσότερη ηρεμία για τους επαγγελματίες.',

    // Mobile
    'mobile.title': 'Ένα mobile εργαλείο για επαγγελματίες σε κίνηση',
    'mobile.text':
      'Με το Petwell οι επαγγελματίες διαχειρίζονται το ημερολόγιο, τις κρατήσεις και την ψηφιακή τους βιτρίνα απευθείας από το smartphone. Μια απλή και ευέλικτη λύση, ιδανική για μετακινήσεις.',

    // Reviews
    'reviews.title': 'Τι λένε οι πελάτες μας',
    'reviews.card1.text':
      'Το PetWell μού επέτρεψε να κερδίσω 30% χρόνο στη διαχείριση της δουλειάς μου.',
    'reviews.card1.role': 'Εκπαιδεύτρια',
    'reviews.card2.text': 'Επιτέλους μια online βιτρίνα προσαρμοσμένη στο επάγγελμά μου.',
    'reviews.card2.role': 'Συμπεριφοριστής',
    'reviews.card3.text':
      'Χάρη στις online προκαταβολές με το PetWell, μείωσα στο μισό τα χαμένα ραντεβού.',
    'reviews.card3.role': 'Groomer',

    // Contact
    'contact.title': 'Επικοινωνήστε μαζί μας',
    'contact.phone_label': 'Τηλέφωνο',
    'contact.email_label': 'Email',

    // Footer
    'footer.copyright': '© 2025 Petwell. Όλα τα δικαιώματα διατηρούνται.',

    // Alts
    'alt.hero_image': 'Γάτα και σκύλος',
    'alt.cat_on_sofa': 'Γάτα σε υπολογιστή',
    'alt.dog_head': 'Ξαπλωμένο κουτάβι',
    'alt.cat_and_mouse': 'Γάτα πίσω από ποντίκι υπολογιστή',
    'alt.cat_headphone': 'Γάτα με ντουντούκα και γυαλιά',
  },
};

const DEFAULT_LANG = 'fr';
const SUPPORTED_LANGS = Object.keys(translations);
const STORAGE_KEY = 'petwell_lang';

function getInitialLang() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const fromUrl = urlParams.get('lang');
    if (fromUrl && SUPPORTED_LANGS.includes(fromUrl)) {
      return fromUrl;
    }
  } catch (e) {
    // ignore
  }

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LANGS.includes(stored)) {
      return stored;
    }
  } catch (e) {
    // ignore
  }

  if (typeof navigator !== 'undefined' && navigator.language) {
    const navLang = navigator.language.toLowerCase();
    if (navLang.startsWith('it')) return 'it';
    if (navLang.startsWith('fr')) return 'fr';
    if (navLang.startsWith('el')) return 'el';
  }

  return DEFAULT_LANG;
}

function updateLangSwitcherUI(lang) {
  const select = document.getElementById('lang-select');
  if (select && select.value !== lang) {
    select.value = lang;
  }
}

function applyTranslations(lang) {
  const dict = translations[lang] || translations[DEFAULT_LANG];

  // Attribut lang sur le <html>
  if (document.documentElement) {
    document.documentElement.lang = lang;
  }

  // Title
  if (dict['meta.title']) {
    document.title = dict['meta.title'];
  }

  // Meta description
  const metaDesc = document.querySelector('meta[name="description"]');
  if (metaDesc && dict['meta.description']) {
    metaDesc.setAttribute('content', dict['meta.description']);
  }

  // Textes
  document.querySelectorAll('[data-i18n-key]').forEach((el) => {
    const key = el.getAttribute('data-i18n-key');
    const value = dict[key];
    if (value) {
      el.textContent = value;
    }
  });

  // Alts
  document.querySelectorAll('[data-i18n-alt]').forEach((el) => {
    const key = el.getAttribute('data-i18n-alt');
    const value = dict[key];
    if (value) {
      el.setAttribute('alt', value);
    }
  });

  updateLangSwitcherUI(lang);

  try {
    window.localStorage.setItem(STORAGE_KEY, lang);
  } catch (e) {
    // ignore
  }
}

function setupLangSwitcher() {
  const select = document.getElementById('lang-select');
  if (!select) return;

  select.addEventListener('change', (event) => {
    const lang = event.target.value;
    if (lang && SUPPORTED_LANGS.includes(lang)) {
      applyTranslations(lang);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const initialLang = getInitialLang();
  setupLangSwitcher();
  applyTranslations(initialLang);
});


